export enum StageType {
  OPEN = 'OPEN',
  WON = 'WON',
  LOST = 'LOST',
}

export interface Product {
  id: number;
  name: string;
  slug: string;
  description?: string;
  logoUrl?: string;
  active: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface PipelineStage {
  id: number;
  productId: number;
  name: string;
  order: number;
  type: StageType;
  color: string;
  createdAt: string;
}

export interface LeadOrigin {
  id: number;
  productId: number;
  name: string;
  active: boolean;
}

export interface CreateProductRequest {
  name: string;
  slug: string;
  description?: string;
  logoUrl?: string;
}

export interface UpdateProductRequest {
  name?: string;
  description?: string;
  logoUrl?: string;
  active?: boolean;
}

export interface CreateStageRequest {
  name: string;
  order: number;
  type: StageType;
  color: string;
}

export interface UpdateStageRequest {
  name?: string;
  order?: number;
  type?: StageType;
  color?: string;
}

export interface CreateOriginRequest {
  name: string;
}

export interface UpdateOriginRequest {
  name?: string;
  active?: boolean;
}
